export const registerURL = "https://app.reaim.me/register"
export const loginURL = "https://app.reaim.me/login"
export const blogURL = "https://blog.reaim.me"
